import {
  ControllerRenderProps,
  useController,
  UseControllerReturn,
} from "react-hook-form"
import { InputField, InputFieldProps } from "./ui/input-field"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type ControlledInputProps = InputFieldProps & {
  filterValue?: (
    field: ControllerRenderProps<any, any>,
  ) => UseControllerReturn<any, any>["field"]
}

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

export function ControlledInput({
  filterValue = (controllerField) => controllerField,
  ...props
}: ControlledInputProps) {
  const controller = useController({ name: props.name })
  const field = filterValue(controller.field)
  return <InputField {...props} {...field} />
}
